import React from 'react';
import Slider from 'react-slick';

import PropTypes from 'prop-types';
import { HeroPropType } from '@/components/HeaderHero/util/heroPropType';
import { HeroSlide as Slide } from './HeroSlide';
import { sliderSettings } from './config/sliderSettings';

import * as S from './styled';

// Slick slider css
import 'slick-carousel/slick/slick.css';

export const HeroSlider = ({ items }) => {
  const totalItems = items.length;

  return (
    <S.Slider aria-roledescription="Caroussel" aria-label="Uitgelichte items">
      <Slider {...sliderSettings}>
        {items.map((item, index) => (
          <Slide
            key={item.id}
            ariaRoleDescription="Slide"
            ariaLabel={`${index + 1} van ${totalItems}`}
            data={item}
          />
        ))}
      </Slider>
    </S.Slider>
  );
};

HeroSlider.propTypes = {
  items: PropTypes.arrayOf(HeroPropType),
};
